module.exports = __webpack_public_path__ + "img/icon-request-card.2a0bb489.svg";